const pickFirst = (...values) => {
  for (const value of values) {
    const normalized = String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (normalized) return normalized;
  }
  return '';
};

const toTitleCase = (value) =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
    .join(' ');

const formatLocation = (property) => {
  const area = pickFirst(property?.area);
  const landmark = pickFirst(property?.landmark);
  const taluk = pickFirst(property?.taluk);
  const district = pickFirst(property?.district);

  const uniqueParts = [area, landmark, taluk, district]
    .filter(Boolean)
    .map((item) => toTitleCase(item))
    .filter((value, index, arr) => arr.findIndex((item) => item.toLowerCase() === value.toLowerCase()) === index);

  return uniqueParts.join(', ');
};

export const buildPropertyImageAlt = (property, options = {}) => {
  const name = pickFirst(property?.property_name, property?.title, property?.property_caption);
  const propertyType = toTitleCase(pickFirst(property?.property_type, property?.propertyType));
  const propertySubType = toTitleCase(pickFirst(property?.property_sub_type, property?.propertySubType));
  const location = formatLocation(property);

  const typeLabel = [propertyType, propertySubType]
    .filter(Boolean)
    .filter((value, index, arr) => arr.findIndex((item) => item.toLowerCase() === value.toLowerCase()) === index)
    .join(' ');

  const baseLabel = toTitleCase(name) || typeLabel || 'Property';
  const contextLabel = pickFirst(options.context) || 'image';
  const position = Number.isFinite(options.index) ? Number(options.index) + 1 : null;
  const total = Number.isFinite(options.total) ? Number(options.total) : null;
  const variant = pickFirst(options.variant).toLowerCase();

  if (variant === 'listing') {
    const typeForListing = toTitleCase(typeLabel || 'Property').toLowerCase();
    const listingPrefix = typeForListing
      ? `${typeForListing.charAt(0).toUpperCase()}${typeForListing.slice(1)}`
      : 'Property';
    return location
      ? `${listingPrefix} for sale in ${location}`
      : `${listingPrefix} for sale`;
  }

  let alt = `${baseLabel}`;
  if (location) alt += ` in ${location}`;
  alt += ` - ${contextLabel}`;

  if (position && total && total > 0) {
    alt += ` ${position} of ${total}`;
  } else if (position) {
    alt += ` ${position}`;
  }

  return alt.replace(/\s+/g, ' ').trim();
};
